import './LogoText.scss';
import Icon from '../Icon/Icon';

interface ButtonProps {
  className?: string;
}

export default function LogoText({ className = '' }: ButtonProps) {
  return (
    <div className={`logo-text ${className}`}>
      <Icon name="logoSbt" />
      <span>Conta SBT</span>
    </div>
  );
}
